module.exports = __webpack_public_path__ + "static/img/custom.eeb0f54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/floating-button/custom.png
// module id = itC0
// module chunks = 48